import axios from "axios";

export const getBlockNumber = () => {
  return axios.get('reports/block-number').then((res) => res).catch((err) => err)
}